'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { FrameQuery, Locale } from '@custom/schema';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { isTruthy } from './isTruthy';
import { useOperation } from './operation';
export var TranslationsContext = /*#__PURE__*/ createContext({
    translations: {},
    setTranslations: function() {}
});
export function TranslationsProvider(param) {
    var children = param.children, defaultTranslations = param.defaultTranslations;
    var _useState = _sliced_to_array(useState(defaultTranslations || {}), 2), translations = _useState[0], setTranslations = _useState[1];
    return /*#__PURE__*/ React.createElement(TranslationsContext.Provider, {
        value: {
            translations: translations,
            setTranslations: setTranslations
        }
    }, children);
}
function deepCompare(a, b) {
    return a && b && Object.keys(a).length === Object.keys(b).length && Object.keys(a).every(function(key) {
        return a[key] === b[key];
    });
}
export function Translations(param) {
    var newTranslations = param.translations, children = param.children;
    var _useContext = useContext(TranslationsContext), setTranslations = _useContext.setTranslations, translations = _useContext.translations;
    useEffect(function() {
        if (newTranslations && !deepCompare(translations, newTranslations)) {
            setTranslations(newTranslations);
        }
    }, [
        setTranslations,
        newTranslations,
        translations
    ]);
    return children;
}
export function useTranslations() {
    var _useOperation_data_websiteSettings_homePage_translations, _useOperation_data_websiteSettings_homePage, _useOperation_data_websiteSettings, _useOperation_data;
    var homeTranslations = Object.fromEntries(((_useOperation_data = useOperation(FrameQuery).data) === null || _useOperation_data === void 0 ? void 0 : (_useOperation_data_websiteSettings = _useOperation_data.websiteSettings) === null || _useOperation_data_websiteSettings === void 0 ? void 0 : (_useOperation_data_websiteSettings_homePage = _useOperation_data_websiteSettings.homePage) === null || _useOperation_data_websiteSettings_homePage === void 0 ? void 0 : (_useOperation_data_websiteSettings_homePage_translations = _useOperation_data_websiteSettings_homePage.translations) === null || _useOperation_data_websiteSettings_homePage_translations === void 0 ? void 0 : _useOperation_data_websiteSettings_homePage_translations.filter(isTruthy).map(function(param) {
        var locale = param.locale, path = param.path;
        return [
            locale,
            path
        ];
    })) || []);
    var translations = useContext(TranslationsContext).translations;
    var homePaths = Object.fromEntries(Object.values(Locale).map(function(locale) {
        return [
            locale,
            "/".concat(locale)
        ];
    }));
    return deepCompare(homeTranslations, translations) ? homePaths : translations;
}
